import { CategoryItem } from "./declarations";

export const CategoryItems: CategoryItem[] = [
  {
    icon: <span className="icon-icon48" />,
    label: "Hot Games",
    tag: "hot_games",
    link: "/games/hot-games",
  },
  {
    icon: <span className="icon-icon48" />,
    label: "General",
    tag: "general",
    link: "/games/hot-games",
  },
  {
    icon: <span className="icon-icon49" />,
    label: "Slot",
    tag: "slot",
    link: "/games/slot",
  },
  {
    icon: <span className="icon-icon50" />,
    label: "Cricket",
    tag: "cricket",
    link: "/games/cricket",
  },
  {
    icon: <span className="icon-icon51" />,
    label: "Live",
    tag: "live",
    link: "/games/live",
  },
  {
    icon: <span className="icon-icon52" />,
    label: "Table Games",
    tag: "table_games",
    link: "/games/table",
  },
  {
    icon: <span className="icon-icon53" />,
    label: "Sports",
    tag: "sports",
    link: "/games/sports",
  },
  {
    icon: <span className="icon-icon54" />,
    label: "Fishing",
    tag: "fishing",
    link: "/games/fishing",
  },
  {
    icon: <span className="icon-icon55" />,
    label: "Crash",
    tag: "crash",
    link: "/games/crash",
  },
];

export const HotGamesDummy = [
  {
    id: "2365",
    provider: "jilislot",
    name: "Super Ace",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/674ebde11eb7e5.71414993.png",
  },
  {
    id: "2226",
    provider: "evo",
    name: "Funky Time",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/675070e811ccb5.42253463.jpg",
  },
  {
    id: "2366",
    provider: "jilislot",
    name: "Money Coming",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/674ebded707f91.17552512.png",
  },
  {
    id: "2497",
    provider: "jilislot",
    name: "Money Coming Expand Bets",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/674f1344a5bff7.65611119.png",
  },
  {
    id: "2375",
    provider: "jilislot",
    name: "Boxing King",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/674ebeb4dcad30.91280591.png",
  },
  {
    id: "2512",
    provider: "jilislot",
    name: "Super Ace Deluxe",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/674f1432ab99a0.22084382.png",
  },
  {
    id: "1157",
    provider: "go888king",
    name: "Big Prosperity Plus",
    gameType: "1002",
    imgUrl: "https://duplomex.s3-ap-southeast-1.amazonaws.com/bo/staging/image/lobby/domain-4/game/043016.png",
  },
  {
    id: "2334",
    provider: "jilislot",
    name: "Chin Shi Huang",
    gameType: "1002",
    imgUrl:
      "https://ijeux-v2.s3-ap-southeast-1.amazonaws.com/staging/bo/image/game_list_image/674ea831f03be7.32616094.png",
  },
];

export const PREFIX_PHONE_NUMBER = "+880";

export enum EFooterProvider {
  "jili",
  "pragmaticplay",
  "pgsoft",
  "evolution",
  "spadegaming",
  "spribe",
  "edgegaming",
  "smartsoft",
  "jdb",
  "playngo",
  "playtech",
  "netent",
  "redtiger",
  "888king",
  "habanero",
  "joker",
  "sabasports",
  "ezugi",
  "aviatrix",
  "crowdplay",
  "sexygaming",
  "bigtimegaming",
}
